/**
 * File-picker checks for recording and commercial audio.
 * The browser "accept" filter can be bypassed (All files, drag and drop),
 * so these run before any length check or upload.
 */

export const MP3_FILE_ERROR =
  "Please choose an MP3 file. Other file types are not allowed."

export const COMMERCIAL_AUDIO_ERROR =
  "Please choose an audio file (MP3, WAV, or WebM). Other file types are not allowed."

export const REPLACE_AUDIO_ERROR =
  "Please choose an audio file (MP3, WAV, M4A, AAC, or OGG). Other file types are not allowed."

export const UNREADABLE_MP3_ERROR =
  "This file could not be read as an MP3. Please choose a real MP3 file."

function extensionOf(file: File): string {
  const name = file.name.toLowerCase()
  const dot = name.lastIndexOf(".")
  return dot >= 0 ? name.slice(dot) : ""
}

/** application/pdf and other non-audio types, even if the name was renamed to .mp3. */
function hasNonAudioType(file: File): boolean {
  const type = (file.type || "").toLowerCase()
  return type.length > 0 && !type.startsWith("audio/")
}

function hasExtension(file: File, allowed: readonly string[]): boolean {
  return allowed.includes(extensionOf(file))
}

export function isMp3File(file: File): boolean {
  if (hasNonAudioType(file)) return false
  const type = (file.type || "").toLowerCase()
  return extensionOf(file) === ".mp3" || type === "audio/mpeg" || type === "audio/mp3"
}

export function isCommercialAudioFile(file: File): boolean {
  if (hasNonAudioType(file)) return false
  return hasExtension(file, [".mp3", ".wav", ".webm"])
}

export function isReplaceableRecordingAudio(file: File): boolean {
  if (hasNonAudioType(file)) return false
  return hasExtension(file, [".mp3", ".wav", ".m4a", ".aac", ".ogg"])
}
